import * as React from "react";
import {IApplicationRootState} from "../../../applicationState";
import {
    clientPerformanceReportingAccess, clientReportingEnabled, cprPortfolioOverviewEnabled,
    currentPlan,
    hasAonTrustCompany,
    hasClientPortfolioAccess,
    hasClientReports,
    hasPortfolioAccess,
    hasResearchAccess,
    insightsEnabled, isEditingPlanPortfolio,
    performanceReportingEnabled,
    sharedDocumentsEnabled
} from "../../../mainReducerMapSelectors";
import {connect} from "react-redux";
import {Home} from "./Home";
import {AtcHome} from "./AtcHome";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";

export interface IHomePropsFromStore {
    insightsEnabled: boolean;
    sharedDocumentsEnabled: boolean;
    hasResearchAccess: boolean;
    hasPortfolioAccess: boolean;
    clientPortfolioEnabled: boolean;
    aonTrustCompany: boolean;
    currentPlan: IPlanInfo;
    clientPerformanceReportingAccess: boolean;
    cprPortfolioOverviewEnabled: boolean;
    editingPlanPortfolio: boolean;
    clientReportingEnabled: boolean;
    performanceReportingEnabled: boolean;
    hasClientReports: boolean;
}

export const HomePage: React.FunctionComponent<IHomePropsFromStore> = (props) => {
    return props.aonTrustCompany
        ? <AtcHome sharedDocumentsEnabled={props.sharedDocumentsEnabled}/>
        : <Home insightsEnabled={props.insightsEnabled}
            sharedDocumentsEnabled={props.sharedDocumentsEnabled}
            hasResearchAccess={props.hasResearchAccess}
            hasPortfolioAccess={props.hasPortfolioAccess}
            clientPortfolioEnabled={props.clientPortfolioEnabled}
            currentPlan={props.currentPlan}
            clientPerformanceReportingAccess={props.clientPerformanceReportingAccess}
            cprPortfolioOverviewEnabled={props.cprPortfolioOverviewEnabled}
            editingPlanPortfolio={props.editingPlanPortfolio}
            clientReportingEnabled={props.clientReportingEnabled}
            performanceReportingEnabled={props.performanceReportingEnabled}
            hasClientReports={props.hasClientReports}
        />;
};

export const mapStateToProps = (state: IApplicationRootState): IHomePropsFromStore => {
    return {
        insightsEnabled: insightsEnabled(state),
        sharedDocumentsEnabled: sharedDocumentsEnabled(state),
        hasResearchAccess: hasResearchAccess(state),
        hasPortfolioAccess: hasPortfolioAccess(state),
        clientPortfolioEnabled: hasClientPortfolioAccess(state),
        aonTrustCompany: hasAonTrustCompany(state),
        currentPlan: currentPlan(state),
        clientPerformanceReportingAccess: clientPerformanceReportingAccess(state),
        cprPortfolioOverviewEnabled: cprPortfolioOverviewEnabled(state),
        editingPlanPortfolio: isEditingPlanPortfolio(state),
        clientReportingEnabled: clientReportingEnabled(state),
        performanceReportingEnabled: performanceReportingEnabled(state),
        hasClientReports: hasClientReports(state)
    };
};

const connectedComponent = connect<IHomePropsFromStore>(mapStateToProps)(HomePage);

export default connectedComponent;